import React, { useEffect } from "react";
import { useSelector } from "react-redux";
// import Modal from "react-modal";
// import {
//   CalendarIcon,
//   CallIcon,
//   CheckCircleIcon,
//   ExcludeIcon,
//   EyeIcon,
//   PersonIcon,
//   XCircleIcon,
// } from "../../../images/icons/icons";
// import {
//   convertStraight,
//   convertThenFormat,
//   formatDateTime,
// } from "../../common-data/Converts";
// import CommonTable from "../../common-components/common-tables/CommonTable";
// import DetailModHeader from "../../common-components/DetailModHeader";
// import TrialAssignForm from "../../pt/three-day-trial/TrialAssignForm";
// import ThreedayTrialHistory from "../../pt/three-day-trial/ThreedayTrialHistory";
// import TrainerMemberMap from "../../trainer-member-engagement/trainer-member-map/TrainerMemberMap";
// import BCAReport from "../../trainer-member-engagement/bca-report/BCAReport";
// import AvailableTrainers from "../live-trials/AvailableTrainers";
import LiveTbCols from "../LiveTbCols";

const RenewalCheckinLogs = ({
  isPage,
  setIsPage,
  pageLimit,
  setPageLimit,
  allDatas,
  setAllDatas,
  userInfoData,
  callFunction,
}) => {
  const { renewalCheckin, renewalCheckinError, renewalCheckinLoading } =
    useSelector((state) => state.live);

  // const iniModValues = {
  //   isModOpen: false,
  //   modName: "",
  //   rowData: "",
  // };
  // const [modValues, setModValues] = useState(iniModValues);

  // const onCloseModal = () => {
  //   setModValues(iniModValues);
  // };

  useEffect(() => {
    if (
      !renewalCheckinLoading &&
      !renewalCheckinError &&
      renewalCheckin?.status &&
      renewalCheckin?.data
    ) {
      setAllDatas((prevs) => ({
        ...prevs,
        allData: renewalCheckin.data,
        pagination:
          renewalCheckin?.pagination?.length > 0
            ? renewalCheckin.pagination
            : [],
      }));
    } else {
      setAllDatas((prevs) => ({
        ...prevs,
        allData: [],
        pagination: [],
      }));
    }
  }, [renewalCheckinLoading, renewalCheckinError, renewalCheckin]);

  // const tbColumns = [
  //   {
  //     dataField: "user_id",
  //     text: "member info",
  //     formatter: (_, row) => {
  //       return (
  //         <div className="tb-flex-col">
  //           <div className="tb-flex">
  //             <span className="tb-data tb-info-icon">
  //               <PersonIcon />
  //             </span>{" "}
  //             <span className="tb-data">{row?.name || "NA"}</span>{" "}
  //           </div>

  //           <div className="tb-flex">
  //             <span className="tb-data tb-info-icon">
  //               <CallIcon />
  //             </span>{" "}
  //             <span className="tb-data">{row?.mobile || "NA"}</span>{" "}
  //           </div>

  //           {(row?.is_renewal === 1 || row?.is_renewal === 0) && (
  //             <div className="tb-flex">
  //               <span
  //                 className={`tb-badge ${
  //                   row?.is_renewal === 1
  //                     ? "tb-existing"
  //                     : row?.is_renewal === 0
  //                     ? "tb-fresh"
  //                     : ""
  //                 }`}
  //               >
  //                 {row?.is_renewal === 1
  //                   ? "Existing Member"
  //                   : row?.is_renewal === 0
  //                   ? "Fresh"
  //                   : "NA"}
  //               </span>
  //             </div>
  //           )}
  //         </div>
  //       );
  //     },
  //   },
  //   {
  //     dataField: "gym_id",
  //     text: "Gym Name",
  //     formatter: (_, row) => {
  //       return <span className="tb-data">{row?.gym_name || "NA"}</span>;
  //     },
  //   },
  //   {
  //     dataField: "plan_id",
  //     text: "plan name",
  //     formatter: (_, row) => {
  //       return (
  //         <div className="tb-flex-col">
  //           <span className="tb-data">{row?.plan_name || "NA"}</span>
  //           <span className="tb-data">
  //             @ ₹{convertThenFormat(row?.price || 0)}
  //           </span>
  //         </div>
  //       );
  //     },
  //   },
  //   {
  //     dataField: "start_date",
  //     text: "start date",
  //     formatter: (_, row) => {
  //       return (
  //         <div className="tb-flex">
  //           <span className="tb-data tb-info-icon">
  //             <CalendarIcon color="#2c3e50" />
  //           </span>{" "}
  //           <span className="tb-data">
  //             {convertStraight(row?.start_date || "-")}
  //           </span>
  //         </div>
  //       );
  //     },
  //   },
  //   {
  //     dataField: "expire_date",
  //     text: "expire date",
  //     formatter: (_, row) => {
  //       return (
  //         <div className="tb-flex">
  //           <span className="tb-data tb-info-icon">
  //             <CalendarIcon color="#2c3e50" />
  //           </span>{" "}
  //           <span className="tb-data">
  //             {convertStraight(row?.expire_date || "-")}
  //           </span>
  //         </div>
  //       );
  //     },
  //   },
  //   {
  //     dataField: "days_remaining",
  //     text: "expiring",
  //     formatter: (_, row) => {
  //       return <span className="tb-data">{row?.days_remaining || 0} days</span>;
  //     },
  //   },
  //   {
  //     dataField: "date_added",
  //     text: "reminder date",
  //     formatter: (_, row) => {
  //       return (
  //         <div className="tb-flex">
  //           <span className="tb-data tb-info-icon">
  //             <CalendarIcon color="#2c3e50" />
  //           </span>{" "}
  //           <span className="tb-data">
  //             {formatDateTime(row?.date_added || "-")}
  //           </span>
  //         </div>
  //       );
  //     },
  //   },
  //   {
  //     dataField: "user_id",
  //     text: "subs added by",
  //     formatter: (_, row) => {
  //       return (
  //         <div className="tb-flex-col">
  //           <div className="tb-flex">
  //             <span className="tb-data tb-info-icon">
  //               <PersonIcon />
  //             </span>{" "}
  //             <span className="tb-data">{row?.created_by_name || "NA"}</span>{" "}
  //           </div>

  //           <div className="tb-flex">
  //             <span className="tb-data tb-info-icon">
  //               <CallIcon />
  //             </span>{" "}
  //             <span className="tb-data">{row?.created_by_mobile || "NA"}</span>{" "}
  //           </div>
  //         </div>
  //       );
  //     },
  //   },
  //   {
  //     dataField: "three_day_assigned",
  //     text: "trial",
  //     formatter: (_, row) => {
  //       return (
  //         <span className="tb-data tb-icon">
  //           {row?.three_day_assigned ? <CheckCircleIcon /> : <XCircleIcon />}
  //         </span>
  //       );
  //     },
  //   },
  //   {
  //     dataField: "three_day_assigned",
  //     text: "trial",
  //     formatter: (_, row) => {
  //       return (
  //         <span
  //           className="tb-data tb-link"
  //           onClick={() =>
  //             setModValues((prevs) => ({
  //               ...prevs,
  //               isModOpen: true,
  //               modName: "trial_history",
  //               rowData: row,
  //             }))
  //           }
  //         >
  //           {row?.three_day_done_count}/3
  //         </span>
  //       );
  //     },
  //   },
  //   {
  //     dataField: "bca_status",
  //     text: "BCA",
  //     formatter: (_, row) => {
  //       return (
  //         <span
  //           className="tb-data tb-link"
  //           onClick={() =>
  //             setModValues((prevs) => ({
  //               ...prevs,
  //               isModOpen: true,
  //               modName: "BCA_history",
  //               rowData: row,
  //             }))
  //           }
  //         >
  //           {row?.bca_status?.replace(/_/g, " ") || "view"}
  //         </span>
  //       );
  //     },
  //   },
  //   {
  //     dataField: "actions",
  //     text: "Actions",
  //     formatter: (_, row) => {
  //       return (
  //         <div className="pp-employee-payroll-actions">
  //           <button
  //             key="pt-trainer"
  //             type="button"
  //             className="pp-employee-payroll-action-button pp-outlined-border"
  //             onClick={() =>
  //               setModValues((prevs) => ({
  //                 ...prevs,
  //                 isModOpen: true,
  //                 modName: "trial_assign",
  //                 rowData: row,
  //               }))
  //             }
  //           >
  //             <ExcludeIcon />
  //             assign PT trial
  //           </button>

  //           <button
  //             key="map-trainer"
  //             type="button"
  //             className="pp-employee-payroll-action-button pp-outlined-border"
  //             onClick={() =>
  //               setModValues((prevs) => ({
  //                 ...prevs,
  //                 isModOpen: true,
  //                 modName: "trainer_member_map",
  //                 rowData: row,
  //               }))
  //             }
  //           >
  //             <ExcludeIcon />
  //             map trainer
  //           </button>

  //           <button
  //             key="available-trainers"
  //             type="button"
  //             className="pp-employee-payroll-action-button pp-outlined-border"
  //             onClick={() =>
  //               setModValues((prevs) => ({
  //                 ...prevs,
  //                 isModOpen: true,
  //                 modName: "view_details",
  //                 rowData: row,
  //               }))
  //             }
  //           >
  //             <EyeIcon />
  //             view
  //           </button>
  //         </div>
  //       );
  //     },
  //   },
  // ];

  return (
    <>
      <LiveTbCols
        from="renewals"
        userInfoData={userInfoData}
        allDatas={allDatas}
        isPage={isPage}
        setIsPage={setIsPage}
        pageLimit={pageLimit}
        setPageLimit={setPageLimit}
        callFunction={callFunction}
        isLoading={renewalCheckinLoading}
      />

      {/* <Modal
        isOpen={modValues.isModOpen}
        onRequestClose={onCloseModal}
        contentLabel="Edit Modal"
        ariaHideApp={false}
      >
        <div
          className={`createNewCTOModalContainer ${
            modValues.modName === "trainer_member_map" ||
            modValues.modName === "view_details"
              ? "mod-width-50p"
              : modValues.modName === "trial_assign"
              ? "mod-width-50p mod-height-60vh"
              : "mod-width-95vw mod-height-95vh"
          }`}
        >
          {modValues.modName === "trial_assign" ||
          modValues.modName === "view_details" ? null : (
            <DetailModHeader
              info={modValues.rowData}
              onClose={onCloseModal}
              isOnlySubscription={true}
            />
          )}

          {modValues.modName === "trial_assign" ? (
            <TrialAssignForm
              rowData={modValues.rowData}
              closeModal={onCloseModal}
              userInfoData={userInfoData}
              callFunction={callFunction}
            />
          ) : modValues.modName === "trial_history" ? (
            <ThreedayTrialHistory
              rowData={modValues.rowData}
              userInfoData={userInfoData}
            />
          ) : modValues.modName === "trainer_member_map" ? (
            <TrainerMemberMap
              userInfoData={userInfoData}
              rowData={modValues.rowData}
              closeModal={onCloseModal}
              callFunction={callFunction}
            />
          ) : modValues.modName === "BCA_history" ? (
            <BCAReport
              userInfoData={userInfoData}
              rowData={modValues.rowData}
            />
          ) : modValues.modName === "view_details" ? (
            <AvailableTrainers
              userInfoData={userInfoData}
              rowData={modValues.rowData}
              closeModal={onCloseModal}
            />
          ) : null}
        </div>
      </Modal>

      <div className="common-table-container mt15">
        <CommonTable
          tableData={allDatas.allData}
          tablePagination={allDatas.pagination}
          tableColumns={tbColumns}
          isPage={isPage}
          setIsPage={setIsPage}
          pageLimit={pageLimit}
          setPageLimit={setPageLimit}
          isLoading={renewalCheckinLoading}
        />
      </div> */}
    </>
  );
};

export default RenewalCheckinLogs;
